// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/app/features/recherche-dossiers/recherche-dossiers.component.scss */
.badge-draft {
  background-color: #6c757d; /* Grey */
  color: white;
}

.bg-successW {
  background-color: #28a745 !important;
}

.bg-primaryy {
  background-color: #ffc107 !important;
}

.bg-dpl {
  background-color: #00a95c;
  color: white;
}

.form-label {
  font-weight: bold !important;
}

.badge-soumis {
  background-color: #007bff; /* Blue */
  color: white;
}

.badge-autorise {
  background-color: #28a745; /* Green */
  color: white;
}

.badge-rejete {
  background-color: #dc3545; /* Red */
  color: white;
}

.bade-valide {
  background-color: #28a745; /* Green */
  color: white;
}

.badge-en_cours_evaluation {
  background-color: #ffc107; /* Yellow */
  color: black;
}

.badge-suspendu {
  background-color: #17a2b8; /* Teal */
  color: white;
}

.badge-retire {
  background-color: #343a40; /* Black */
  color: white;
}

.badge-expire {
  background-color: #f8f9fa; /* Light Gray */
  color: black;
}

th {
  color: white !important;
  background-color: #00a95c;
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./src/app/features/dossier/components/recherche-dossiers/recherche-dossiers.component.scss"],"names":[],"mappings":"AAAA,0EAAA;AACA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,oCAAA;AACF;;AAEA;EACE,yBAAA;EACA,YAAA;AACF;;AACA;EACE,4BAAA;AAEF;;AAAA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,QAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,WAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,SAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,UAAA;EACA,YAAA;AAGF;;AAAA;EACE,yBAAA,EAAA,eAAA;EACA,YAAA;AAGF;;AADA;EACE,uBAAA;EACA,yBAAA;AAIF;AACA,44EAA44E","sourcesContent":["/* src/app/features/recherche-dossiers/recherche-dossiers.component.scss */\n.badge-draft {\n  background-color: #6c757d; /* Grey */\n  color: white;\n}\n\n.bg-successW {\n  background-color: #28a745 !important;\n}\n\n.bg-primaryy {\n  background-color: #ffc107 !important;\n}\n\n.bg-dpl {\n  background-color: #00a95c;\n  color: white;\n}\n.form-label {\n  font-weight: bold !important;\n}\n.badge-soumis {\n  background-color: #007bff; /* Blue */\n  color: white;\n}\n\n.badge-autorise {\n  background-color: #28a745; /* Green */\n  color: white;\n}\n\n.badge-rejete {\n  background-color: #dc3545; /* Red */\n  color: white;\n}\n\n.bade-valide {\n  background-color: #28a745; /* Green */\n  color: white;\n}\n\n.badge-en_cours_evaluation {\n  background-color: #ffc107; /* Yellow */\n  color: black;\n}\n\n.badge-suspendu {\n  background-color: #17a2b8; /* Teal */\n  color: white;\n}\n\n.badge-retire {\n  background-color: #343a40; /* Black */\n  color: white;\n}\n\n.badge-expire {\n  background-color: #f8f9fa; /* Light Gray */\n  color: black;\n}\nth {\n  color: white !important;\n  background-color: #00a95c;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
